export default __webpack_public_path__ + "static/media/dummy-image-square.368b8954.jpg";